import React from 'react'
import {Navigate,Outlet} from 'react-router-dom'
import { useEyeconxStore } from '../store/eyeconxStore'
import ServerNotifications from '../components/helpers/ServerNotifications'

const PrivateRoutes = () =>{
    const isAuthenticated  = useEyeconxStore(state => state.isAuthenticated)
    const user = useEyeconxStore((state)=>(state.user))
    return(
        isAuthenticated?<div><Outlet/><ServerNotifications clinicId={user.clinicId} /></div>:<Navigate to="/login"/>
    )
}
export default PrivateRoutes;
